import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiFab = ({ palette, misc, elevation }: Pick<Tokens, 'palette' | 'misc' | 'elevation'>) =>
  ({
    MuiFab: {
      defaultProps: {
        size: 'large',
      },
      styleOverrides: {
        root: {
          boxShadow: elevation.lg,
          textTransform: 'none',

          ...misc.createFocusVisibleState({
            outlineStyle: 'solid',
            outlineWidth: misc.borderSize(3),
            outlineOffset: misc.borderSize(-3),
            boxShadow: 'none',
            outlineColor: palette.primary.states.focus,
          }),
          '&:not(:focus-visible):not(:disabled):active': {
            opacity: 0.8,
            boxShadow: 'none',
          },
        },
      },
      variants: [
        {
          props: { variant: 'extended' },
          style: {
            gap: spacing(1),
          },
        },
        {
          props: { size: 'small' },
          style: {
            svg: {
              fontSize: spacing(2.5),
            },
          },
        },
        {
          props: { size: 'small' },
          style: {
            height: spacing(5),
            minHeight: spacing(5),
          },
        },
        {
          props: { size: 'small', variant: 'circular' },
          style: {
            width: spacing(5),
          },
        },
        {
          props: { size: 'small', variant: 'extended' },
          style: {
            borderRadius: spacing(5),
          },
        },

        {
          props: { size: 'medium' },
          style: {
            height: spacing(6),
            minHeight: spacing(6),
          },
        },
        {
          props: { size: 'medium', variant: 'circular' },
          style: {
            width: spacing(6),
          },
        },
        {
          props: { size: 'medium', variant: 'extended' },
          style: {
            borderRadius: spacing(6),
          },
        },

        {
          props: { size: 'large' },
          style: {
            height: spacing(7),
            minHeight: spacing(7),
          },
        },
        {
          props: { size: 'large', variant: 'circular' },
          style: {
            width: spacing(7),
          },
        },
        {
          props: { size: 'large', variant: 'extended' },
          style: {
            borderRadius: spacing(7),
          },
        },
      ],
    },
  }) satisfies ComponentCreation
